import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  CSpinner,
  CTable,
  CTableHead,
  CTableRow,
  CTableHeaderCell,
  CTableBody,
  CTableDataCell,
  CBadge,
  CButton,
} from "@coreui/react";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

const DeviceAlertsTab = ({ cameraId }) => {
  const { t } = useTranslation();
  const [alerts, setAlerts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAlerts = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get(`/api/devices/${cameraId}/alerts/`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setAlerts(res.data);
      } catch (e) {
        console.error("Ошибка при загрузке уведомлений:", e);
      } finally {
        setLoading(false);
      }
    };
    fetchAlerts();
  }, [cameraId]);

  if (loading)
    return (
      <div className="text-center p-4">
        <CSpinner color="primary" />
      </div>
    );
  if (alerts.length === 0)
    return (
      <div className="text-center p-4 text-muted">
        {t("alerts.no_alerts", "Уведомлений от устройства не поступало")}
      </div>
    );

  return (
    <div className="table-responsive">
      <CTable hover responsive small align="middle">
        <CTableHead color="light">
          <CTableRow>
            <CTableHeaderCell>
              {t("alerts.time", "Время события")}
            </CTableHeaderCell>
            <CTableHeaderCell>{t("alerts.category", "Тип")}</CTableHeaderCell>
            <CTableHeaderCell>
              {t("alerts.message", "Сообщение")}
            </CTableHeaderCell>
            <CTableHeaderCell className="text-center">
              {t("alerts.screenshot", "Фото")}
            </CTableHeaderCell>
          </CTableRow>
        </CTableHead>
        <CTableBody>
          {alerts.map((a) => (
            <CTableRow key={a.id}>
              <CTableDataCell className="text-nowrap fw-semibold">
                {dayjs(a.device_timestamp).format("DD.MM.YYYY HH:mm:ss")}
              </CTableDataCell>
              <CTableDataCell>
                <CBadge color="danger">{a.category_display}</CBadge>
              </CTableDataCell>
              <CTableDataCell className="text-muted small">
                {a.message}
              </CTableDataCell>
              <CTableDataCell className="text-center">
                {a.screenshot ? (
                  <a href={a.screenshot} target="_blank" rel="noreferrer">
                    <CButton size="sm" color="primary" variant="outline">
                      {t("alerts.view_full", "Смотреть")}
                    </CButton>
                  </a>
                ) : (
                  "-"
                )}
              </CTableDataCell>
            </CTableRow>
          ))}
        </CTableBody>
      </CTable>
    </div>
  );
};

export default DeviceAlertsTab;